import { useMediaByIds } from './useMediaByIds'
import { usePublicUploadFile, useUploadFile } from './useUploadFile'
import { useUploadImage } from './useUploadImage'

export const media = {
  uploadImage: useUploadImage,
  uploadFile: useUploadFile,
  uploadPublicFile: usePublicUploadFile,
  byIds: useMediaByIds,
}
